<template>
  <div class="ricerca col-24 no-padding">
    <ricerca-panel :filtri="filtriRicerca"
                   @closeRicerca="closeRicerca"
                   @changeValueOrClick="changeValueOrClick"
                   @remoteMethod="remoteMethod"
                   @cerca="cerca"></ricerca-panel>
  </div>
</template>

<script>
  import {bus} from '../../Bus'
  import RicercaPanel from '@/components/ServiceComponents/RicercaPanel'
  import moment from 'moment'

  export default {
    name: 'Ricerca',
    components: {RicercaPanel},
    i18n: {
      messages: {
        it_IT: {
          ricerca: {
            stato: 'Stato',
            fornitore: 'Fornitore',
            stabilimento: 'Stabilimento',
            dataBolla: 'Data Bolla',
            ricerca: 'Cerca',
            scegli: 'Scegli...',
            filtri: 'Filtri',
            numConf: 'Numero Conferma',
            numBuono: 'Numero Buono',
            dataSped: 'Data Spedizione'
          }
        },
        fr_FR: {
          ricerca: {
            stato: 'Nation',
            fornitore: 'Fournisseur',
            stabilimento: 'Site',
            dataBolla: 'Date Bon de Livraison (BDL)',
            ricerca: 'Recherche',
            scegli: 'Choisir...',
            filtri: 'Filtres',
            numConf: 'Numéro de Confirmation',
            numBuono: 'Numéro du Coupon',
            dataSped: 'Date d\'Expédition'
          }
        },
        es_ES: {
          ricerca: {
            stato: 'Estado',
            fornitore: 'Proveedor',
            stabilimento: 'Fabrica',
            dataBolla: 'Fecha Factura',
            ricerca: 'Buscar',
            scegli: 'Elegir...',
            filtri: 'Filtros',
            numConf: 'Numero de Confirmacion',
            numBuono: 'Número vale descarga',
            dataSped: 'Fecha de Envio'
          },
        },
        de_DE: {
          ricerca: {
            stato: 'Land',
            fornitore: 'Lieferant',
            stabilimento: 'Werke',
            dataBolla: 'Eingangsdatum',
            ricerca: 'Suche',
            scegli: 'Wählen...',
            filtri: 'Filter',
            numConf: 'Vertragsnummer',
            numBuono: 'Entladeschein',
            dataSped: 'Versanddatum'
          }
        },
        en_GB: {
          ricerca: {
            stato: 'Country',
            fornitore: 'Supplier',
            stabilimento: 'Factory',
            dataBolla: 'Bill\'s Date',
            ricerca: 'Search',
            scegli: 'Choose...',
            filtri: 'Filters',
            numConf: 'Confirmation Number',
            numBuono: 'Voucher Number',
            dataSped: 'Shipping Date'
          }
        }
      }
    },
    data () {
      return {
        filtriRicerca: {
          loading: false,
          titolo: '',
          valueSelected: {
            0: '',
            1: {},
            2: '',
            3: [],
            4: [],
            5: '',
            6: ''
          },
          dati: {
            0: [],
            1: [],
            2: []
          },
          filtri: [
            // Select con le country a cui è abilitato l'utente
            {
              type: 'select',
              myLabel: '',
              value: 'country',
              label: 'desc',
              key: 'country',
              onChangeOrClick: 'changeCountry',
              ifClearable: false,
              ifDisabled: false
            },
            // Select con i codici fornitore e spedizioniere
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['codForn', 'descForn'],
              key: 'codForn',
              onChangeOrClick: 'changeCodForn',
              ifClearable: false,
              ifDisabled: false,
              ifShow: false
            },
            // Select con gli Stabilimenti
            {
              type: 'select',
              myLabel: '',
              value: 'codStab',
              label: 'descStab',
              key: 'codStab',
              onChangeOrClick: 'changeStab',
              ifClearable: false,
              ifDisabled: true
            },
            // Date picker con range di ricerca per DATA ENTRATA
            {
              type: 'dt-picker',
              myLabel: '',
              ifClearable: false,
              format: 'dd/MM/yyyy',
              valueFormat: 'yyyyMMdd',
              typePicker: 'daterange',
              onChangeOrClick: 'changeRangeDataEntrata'
            },
            // Date picker con range di ricerca per DATA SPEDIZIONE
            {
              type: 'dt-picker',
              myLabel: '',
              ifClearable: false,
              format: 'dd/MM/yyyy',
              valueFormat: 'yyyyMMdd',
              typePicker: 'daterange',
              onChangeOrClick: 'changeRangeDataSped'
            },
            // Input per numero conferma
            {
              type: 'input',
              myLabel: '',
              ifClearable: true,
              onChangeOrClick: 'changeNumConf'
            },
            // Input per numero buono
            {
              type: 'input',
              myLabel: '',
              ifClearable: true,
              onChangeOrClick: 'changeNumBuono'
            }
          ]
        },
        codLang: sessionStorage.getItem('codLang'),
        form: {
          country: '',
          fornitore: {},
          codStab: '',
          dataBolla: [],
          dataSped: [],
          numConf: '',
          numBuono: ''
        },
        codForn: '',
        codFornAdmin: {}
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.codLang = sessionStorage.getItem('codLang')
        this.$nextTick(() => {
          this.getCountries()
          this.setTraduzioniLabel()
        })
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          this.$set(this, 'codForn', this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]])
        } else {
          this.$set(this, 'codFornAdmin', {})
          this.$set(this, 'codForn', '')
        }
        if (!this._inactive) {
          this.$set(this.form, 'fornitore', {})
          this.$set(this.form, 'codStab', '')
          this.$set(this.form, 'numBuono', '')
          this.$set(this.form, 'numConf', '')
          this.filtriRicerca.valueSelected[1] = {}
          this.filtriRicerca.valueSelected[2] = ''
          this.filtriRicerca.valueSelected[5] = ''
          this.filtriRicerca.valueSelected[6] = ''

          let dataDa = moment(new Date(new Date().getTime() - (604800000))).format('YYYYMMDD')
          let dataA = moment(new Date()).format('YYYYMMDD')
          this.$set(this.form, 'dataBolla', [])
          this.form.dataBolla.push(dataDa)
          this.form.dataBolla.push(dataA)
          this.filtriRicerca.valueSelected[3] = this.form.dataBolla
          this.$set(this.form, 'dataSped', [])
          this.form.dataSped.push(dataDa)
          this.form.dataSped.push(dataA)
          this.filtriRicerca.valueSelected[4] = this.form.dataSped

          this.filtriRicerca.dati[1] = []
          this.filtriRicerca.dati[2] = []
          this.$set(this.form, 'country', this.filtriRicerca.valueSelected[0])
          if (this.codForn !== '') {
            this.getStabilimenti()
          }
        }
      })
      bus.$on('TRAACQ_ChangeCountryFromDsh', () => {
        this.filtriRicerca.valueSelected[0] = localStorage.getItem('TRAACQ_country')
      })
    },
    deactivated: function () {
      this.$set(this.form, 'fornitore', {})
      this.$set(this.form, 'codStab', '')
      this.$set(this.form, 'numBuono', '')
      this.$set(this.form, 'numConf', '')
      this.filtriRicerca.valueSelected[1] = {}
      this.filtriRicerca.valueSelected[2] = ''
      this.filtriRicerca.valueSelected[5] = ''
      this.filtriRicerca.valueSelected[6] = ''

      let dataDa = moment(new Date(new Date().getTime() - (604800000))).format('YYYYMMDD')
      let dataA = moment(new Date()).format('YYYYMMDD')
      this.$set(this.form, 'dataBolla', [])
      this.form.dataBolla.push(dataDa)
      this.form.dataBolla.push(dataA)
      this.filtriRicerca.valueSelected[3] = this.form.dataBolla
      this.$set(this.form, 'dataSped', [])
      this.form.dataSped.push(dataDa)
      this.form.dataSped.push(dataA)
      this.filtriRicerca.valueSelected[4] = this.form.dataSped

      this.filtriRicerca.dati[1] = []
      this.filtriRicerca.dati[2] = []
    },
    activated: function () {
      if (sessionStorage.hasOwnProperty('WSR_form')) {
        this.$set(this, 'form', JSON.parse(sessionStorage.getItem('WSR_form')))
        this.filtriRicerca.valueSelected[0] = this.form.country
        this.filtriRicerca.valueSelected[1] = this.form.fornitore
        this.$set(this, 'codForn', this.form.fornitore.tipForn + this.form.fornitore.codForn)
        this.filtriRicerca.valueSelected[2] = this.form.codStab
        this.filtriRicerca.valueSelected[3] = this.form.dataBolla
        this.filtriRicerca.valueSelected[4] = this.form.dataSped
        this.filtriRicerca.valueSelected[5] = this.form.numConf
        this.filtriRicerca.valueSelected[6] = this.form.numBuono
      } else {
        let dataDa = moment(new Date(new Date().getTime() - (604800000))).format('YYYYMMDD')
        let dataA = moment(new Date()).format('YYYYMMDD')
        this.$set(this.form, 'dataBolla', [])
        this.form.dataBolla.push(dataDa)
        this.form.dataBolla.push(dataA)
        this.filtriRicerca.valueSelected[3] = this.form.dataBolla
        this.$set(this.form, 'dataSped', [])
        this.form.dataSped.push(dataDa)
        this.form.dataSped.push(dataA)
        this.filtriRicerca.valueSelected[4] = this.form.dataSped
      }
      if (localStorage.hasOwnProperty('amministrazione')) {
        this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
      }

      this.filtriRicerca.valueSelected[3] = this.form.dataBolla
      this.filtriRicerca.valueSelected[4] = this.form.dataSped

      this.codLang = sessionStorage.getItem('codLang')

      this.$nextTick(() => {
        this.getCountries()
        this.setTraduzioniLabel()
      })
    },
    methods: {
      changeNumConf: function () {
        this.$set(this.form, 'numConf', this.filtriRicerca.valueSelected[5])
      },
      changeNumBuono: function () {
        this.$set(this.form, 'numBuono', this.filtriRicerca.valueSelected[6])
      },
      changeStab: function () {
        this.$set(this.form, 'codStab', this.filtriRicerca.valueSelected[2])
      },
      setTraduzioniLabel: function () {
        this.filtriRicerca.titolo = this.$t('ricerca.filtri')
        this.$set(this.filtriRicerca, 'titolo', this.$t('ricerca.filtri'))
        this.$set(this.filtriRicerca.filtri[0], 'myLabel', this.$t('ricerca.stato'))
        // this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.fornitore'))
        this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.fornitore'))
        this.$set(this.filtriRicerca.filtri[2], 'myLabel', this.$t('ricerca.stabilimento'))
        this.$set(this.filtriRicerca.filtri[3], 'myLabel', this.$t('ricerca.dataBolla'))
        this.$set(this.filtriRicerca.filtri[4], 'myLabel', this.$t('ricerca.dataSped'))
        this.$set(this.filtriRicerca.filtri[5], 'myLabel', this.$t('ricerca.numConf'))
        this.$set(this.filtriRicerca.filtri[6], 'myLabel', this.$t('ricerca.numBuono'))
      },
      closeRicerca: function () {
        this.$emit('closeRicerca')
      },
      changeValueOrClick: function (index, value) {
        if (this.filtriRicerca.filtri[index].hasOwnProperty('onChangeOrClick')) {
          this[this.filtriRicerca.filtri[index].onChangeOrClick](value)
        }
      },
      cerca: function () {
        let fornitore = {
          codForn: this.codForn.substring(1),
          tipForn: this.codForn.substring(0, 1)
        }
        this.$set(this.form, 'fornitore', fornitore)
        sessionStorage.setItem('WSR_form', JSON.stringify(this.form))
        if (sessionStorage.getItem('TRAACQ_fornitore') !== this.codForn) {
          sessionStorage.setItem('TRAACQ_fornitore', this.codForn)
          bus.$emit('TRAACQ_ChangeCountryFromApp')
        }
        this.$nextTick(() => {
          this.$emit('ricerca')
        })
      },
      remoteMethod: function (index, query) {
        if (this.filtriRicerca.filtri[index].hasOwnProperty('remoteMethod')) {
          this[this.filtriRicerca.filtri[index].remoteMethod](query)
        }
      },
      changeRangeDataEntrata: function () {
        if (this.filtriRicerca.valueSelected[3] === null) {
          this.filtriRicerca.valueSelected[3] = []
          this.form.dataBolla = []
        } else {
          this.form.dataBolla = this.filtriRicerca.valueSelected[3]
        }
      },
      changeRangeDataSped: function () {
        if (this.filtriRicerca.valueSelected[4] === null) {
          this.filtriRicerca.valueSelected[4] = []
          this.form.dataSped = []
        } else {
          this.form.dataSped = this.filtriRicerca.valueSelected[4]
        }
      },
      getFornitoreInfo: function (ifChangeCountry) {
        this.$http.get('storicorottame/info', {
          params: {
            codLang: this.codLang,
            country: this.form.country
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              if (response.body.attrib.typeOfUser === 'fornitore') {
                // this.filtriRicerca.filtri[1].typeOfUser = 'fornitore'
                this.filtriRicerca.dati[1] = response.body.data
                this.filtriRicerca.filtri[1].ifDisabled = (response.body.data.length <= 1)
                this.filtriRicerca.filtri[1].ifShow = true
                if (!sessionStorage.hasOwnProperty('WSR_form') || ifChangeCountry) {
                  if (sessionStorage.hasOwnProperty('TRAACQ_fornitore')) {
                    let TRAACQ_fornitore = sessionStorage.getItem('TRAACQ_fornitore')
                    let flag = false
                    response.body.data.forEach((forn) => {
                      if ((forn.tipForn + forn.codForn) === (TRAACQ_fornitore)) {
                        flag = true
                        this.filtriRicerca.valueSelected[1] = forn
                        this.$set(this.form, 'fornitore', forn)
                        this.$set(this, 'codForn', forn.tipForn + forn.codForn)
                      }
                    })
                    if (flag === false) {
                      this.filtriRicerca.valueSelected[1] = response.body.data[0]
                      this.$set(this.form, 'fornitore', response.body.data[0])
                      this.$set(this, 'codForn', response.body.data[0].tipForn + response.body.data[0].codForn)
                    }
                  } else {
                    this.filtriRicerca.valueSelected[1] = response.body.data[0]
                    this.$set(this.form, 'fornitore', response.body.data[0])
                    this.$set(this, 'codForn', response.body.data[0].tipForn + response.body.data[0].codForn)
                  }
                }
                this.getStabilimenti()
              } else if (response.body.attrib.typeOfUser === 'admin') {
                // this.filtriRicerca.filtri[1].typeOfUser = 'admin'
                if (localStorage.hasOwnProperty('amministrazione') && this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]] !== '') {
                  this.$set(this, 'codForn', this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]])
                }
                this.filtriRicerca.filtri[1].ifShow = false
                if (this.codForn !== '') {
                  // this.getListFornAdm(this.form.fornitore.codForn)
                  this.getStabilimenti()
                } else {
                  this.$emit('stopLoading')
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeCodForn: function () {
        this.$set(this.form, 'codStab', '')
        this.$set(this.form, 'numBuono', '')
        this.$set(this.form, 'numConf', '')
        this.filtriRicerca.valueSelected[2] = ''
        this.filtriRicerca.valueSelected[5] = ''
        this.filtriRicerca.valueSelected[6] = ''
        this.filtriRicerca.filtri[2].ifDisabled = true

        let dataDa = moment(new Date(new Date().getTime() - (604800000))).format('YYYYMMDD')
        let dataA = moment(new Date()).format('YYYYMMDD')
        this.$set(this.form, 'dataBolla', [])
        this.form.dataBolla.push(dataDa)
        this.form.dataBolla.push(dataA)
        this.filtriRicerca.valueSelected[3] = this.form.dataBolla
        this.$set(this.form, 'dataSped', [])
        this.form.dataSped.push(dataDa)
        this.form.dataSped.push(dataA)
        this.filtriRicerca.valueSelected[4] = this.form.dataSped

        this.filtriRicerca.dati[2] = []
  
        this.$set(this.form, 'fornitore', this.filtriRicerca.valueSelected[1])
        this.$set(this, 'codForn', this.filtriRicerca.valueSelected[1].tipForn + this.filtriRicerca.valueSelected[1].codForn)
        this.getStabilimenti()
      },
      getCountries: function () {
        this.$http.get('portale/countries', {
          params: {
            codLang: this.codLang,
            codiApp: 'WebStoricoRottame'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.filtriRicerca.dati[0] = response.body.data
              if (!sessionStorage.hasOwnProperty('WSR_form')) {
                let flag = false
                response.body.data.forEach((obj) => {
                  if (obj.country === localStorage.getItem('TRAACQ_country')) {
                    flag = true
                  }
                })
                if (flag === true) {
                  this.filtriRicerca.valueSelected[0] = localStorage.getItem('TRAACQ_country')
                  this.$set(this.form, 'country', localStorage.getItem('TRAACQ_country'))
                } else {
                  this.filtriRicerca.valueSelected[0] = response.body.data[0].country
                  this.$set(this.form, 'country', response.body.data[0].country)
                }
              }
              this.getFornitoreInfo()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeCountry: function () {
        this.$set(this.form, 'fornitore', {})
        this.$set(this.form, 'codStab', '')
        this.$set(this.form, 'numBuono', '')
        this.$set(this.form, 'numConf', '')
        this.filtriRicerca.valueSelected[1] = {}
        this.filtriRicerca.valueSelected[2] = ''
        this.filtriRicerca.valueSelected[5] = ''
        this.filtriRicerca.valueSelected[6] = ''

        let dataDa = moment(new Date(new Date().getTime() - (604800000))).format('YYYYMMDD')
        let dataA = moment(new Date()).format('YYYYMMDD')
        this.$set(this.form, 'dataBolla', [])
        this.form.dataBolla.push(dataDa)
        this.form.dataBolla.push(dataA)
        this.filtriRicerca.valueSelected[3] = this.form.dataBolla
        this.$set(this.form, 'dataSped', [])
        this.form.dataSped.push(dataDa)
        this.form.dataSped.push(dataA)
        this.filtriRicerca.valueSelected[4] = this.form.dataSped

        this.filtriRicerca.dati[1] = []
        this.filtriRicerca.dati[2] = []
        this.$set(this.form, 'country', this.filtriRicerca.valueSelected[0])
        sessionStorage.removeItem('TRAACQ_fornitore')
        this.$emit('changeCountry')
        this.getFornitoreInfo(true)
      },
      getStabilimenti: function () {
        this.$http.get('storicorottame/stabilimenti', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1)
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.filtriRicerca.dati[2] = response.body.data
              if (response.body.data.length > 0) {
                if (this.form.codStab === '') {
                  this.form.codStab = response.body.data[0].codStab
                  this.filtriRicerca.valueSelected[2] = response.body.data[0].codStab
                  if (!sessionStorage.hasOwnProperty('WSR_form')) {
                    // this.cerca()
                  }
                }
                this.filtriRicerca.filtri[2].ifDisabled = false
              }
              this.$emit('stopLoading')
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .ricerca {
    height: 100%;
    position: absolute;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebStoricoRottame/Ricerca.vue